import { Button, Card, Col, Form, Input, message, Popconfirm, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addState, deleteState, getAllState, updateState } from '../../redux/rtk/features/masters/stateSlice';
import PageTitle from '../page-header/PageHeader';

const StateMaster = () => {
  const { Title } = Typography;
  const [editingState, setEditingState] = useState(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state.state);

  useEffect(() => {
    dispatch(getAllState());
  }, [dispatch]);



  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      if (editingState) {
        // Update existing state
        const result = await dispatch(
          updateState({ id: editingState.id, values })
        ).unwrap();
        if (result.message === 'success') {
          dispatch(getAllState());
        } else {
          message.error('Error updating state!');
        }
      } else {
        // Add new state
        const result = await dispatch(addState(values)).unwrap();
        if (result.message === 'success') {
          dispatch(getAllState());
        } else {
          message.error('Error adding state!');
        }
      }
      setEditingState(null);
    } catch (error) {
      console.error('Validation failed or API error:', error);
      message.error('Failed to add or update state!');
    }
  };

  // Handle deletion
  const handleDelete = async (id) => {
    try {
      const result = await dispatch(deleteState(id)).unwrap();
      if (result?.message === 'success') {
        dispatch(getAllState()); // Refresh table data
      } else {
      }
    } catch (error) {
      console.error('Delete API error:', error);
    }
  };

  // Table columns
  const columns = [
    {
      title: 'City',
      dataIndex: 'stateName',
      key: 'stateName',
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => {
            setEditingState(record);
            form.setFieldsValue(record);
          }}>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this state?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <PageTitle title='Back' />
      <Row gutter={16}>
        <Col span={8}>
          <Card title={editingState ? 'Edit City' : 'Add City'}>

            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name="category-form"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 14 }}
              onFinish={handleSubmit}
              autoComplete="off"
            >
              <Form.Item
                name="stateName"
                label="City"
                rules={[{ required: true, message: 'Please enter a City!' }]}
              >
                <Input placeholder="Enter City" />
              </Form.Item>

              <Button type="primary" block htmlType="submit">
                {editingState ? 'Update City' : 'Add City'}
              </Button>
            </Form>
          </Card>
        </Col>
        <Col span={16}>
          <Card title="City List">
            <Table
              dataSource={list}
              columns={columns}
              rowKey="id"
              loading={loading}
              style={{ marginTop: 0 }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default StateMaster;
